import { apiGet, apiDelete } from './api';

/* ──────────────────────────────────────────
   Discord — vinculacao de conta (+VIP)
   ────────────────────────────────────────── */

export interface DiscordLinkStatus {
  enabled: boolean;
  linked: boolean;
  discordId?: string;
  discordUsername?: string;
  linkedAt?: string;
  rewardGranted: boolean;
  rewardDays: number;
}

/** GET /discord/link/status — estado da vinculacao do player logado */
export const getDiscordStatus = () =>
  apiGet<DiscordLinkStatus>('/discord/link/status');

/** GET /discord/link/start — devolve a URL de autorizacao do Discord */
export const startDiscordLink = () =>
  apiGet<{ url: string }>('/discord/link/start');

/** DELETE /discord/link — desvincula o Discord da conta */
export const unlinkDiscord = () =>
  apiDelete<{ status: string; message: string }>('/discord/link');
